import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { AdminButton } from "../../../components/buttons/versionHistoryBtn";
import SelectCustomField from "../../form/selectField/selectCustomField";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import {
  customerEditProductOffer,
  customerProductOfferList,
  productOfferValue,
} from "../../../redux/actions/customerActions";
import { useDispatch } from "react-redux";
import ChangeSaved from "../../popups/ChangeSaved";
import ErrorPopup from "../../popups/ErrorPopup";
import { useParams } from "react-router-dom";

const UpdateProductOfferModal = ({
  show,
  ShowClose,
  districtName,
  stateName,
  divisionName,
  productDetails,
}) => {
  const dispatch = useDispatch();
  const params = useParams();
  const [offerList, setOfferList] = useState([]);

  useEffect(() => {
    if (show) {
      fetchProductOffer(productDetails.product_id);
    }
  }, [show]);

  const fetchProductOffer = (product_id) => {
    if (product_id) {
      dispatch(
        customerProductOfferList(
          {
            doctor_id: params?.id,
            product_id: product_id,
          },
          onListSuccess,
          onGetError
        )
      );
    }
  };

  const onListSuccess = (data) => {
    console.log(data);
    let newArr = data.data.data.product.offers.map((ele) => ({
      value: ele?.id,
      label:
        ele?.offer_type === "quantity"
          ? `${ele?.offer} + ${ele?.offer_qty}`
          : ele.after_off,
    }));
    setOfferList(newArr);
  };

  const onGetError = (err) => {
    console.log(err);
  };

  const initialValues = {
    offer_id: "",
  };
  const validationSchema = Yup.object().shape({
    offer_id: Yup.string().required("Required"),
  });

  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [onSuccessShow, onSetSuccessShow] = useState(false);
  const [onSuccessMsg, onSetSuccessMsg] = useState("");

  const timeOutFnc = () => {
    onSetSuccessShow(false);
    ShowClose();
  };
  const onSubmit = (values) => {
    const dispatchValues = {
      doctor_id: params?.id,
      request_id: productDetails?.id,
      offer_id: values.offer_id,
    };
    let selectedOffer = offerList?.find(
      (item) => item.value === values.offer_id
    );
    const parts = selectedOffer.label ? selectedOffer.label.split(" + ") : [];
    dispatch(customerEditProductOffer(dispatchValues, onSuccess, onError));
    dispatch(
      productOfferValue({
        offerValue: {
          product_id: productDetails.product_id,
          offer: parts[0] ?? 0,
          offer_qty: parts[1] ?? 0,
        },
      })
    );
  };

  const onSuccess = (data) => {
    console.log(data);
    onSetSuccessShow(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    onSetSuccessMsg(str_modify);
    ShowClose();
    setTimeout(timeOutFnc, 2000);
  };
  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    ShowClose();
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={ShowClose}
        contentClassName="link-modal col-5 mx-auto p-2 fn_Nunito"
      >
        <div className="m-2">
          <div className="fn_Nunito fs_18 mt-3 ms-2 fw_900">
            <h2>Update Offer</h2>
          </div>

          <ModalBody>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              enableReinitialize={true}
            >
              {({ setFieldValue, values }) => (
                <Form>
                  <div className="d-flex flex-column justify-content-start align-items-start">
                    <div className="fn_Nunito fs_14">
                      <label className="color_747f9e">Division</label>
                      <p className="color_2623cb">{divisionName}</p>
                    </div>
                    <div className="fn_Nunito fs_14">
                      <label className="color_747f9e">State</label>
                      <p className="color_2623cb">{stateName}</p>
                    </div>
                    <div className="fn_Nunito fs_14">
                      <label className="color_747f9e">District</label>
                      <p className="color_2623cb">{districtName}</p>
                    </div>
                    <div className="fn_Nunito fs_14">
                      <label className="color_747f9e">Product Name</label>
                      <p className="color_2623cb">
                        {productDetails.product.product_name ?? "--"}
                      </p>
                    </div>

                    <div className="w-100">
                      <SelectCustomField
                        label={"Offer"}
                        labelColor={"color_262c3d"}
                        placeholder={"Select Offer"}
                        optionList={offerList}
                        name={"offer_id"}
                        id={"offer_id"}
                        menuHeight="130px"
                        value={values.offer_id}
                        onChange={() => ""}
                      />
                    </div>
                  </div>

                  <div className=" d-flex m-1 ">
                    <AdminButton
                      width="266px"
                      height="52px"
                      type="button"
                      color="#FF6F5B"
                      border="1px solid #FF6F5B"
                      onClick={() => ShowClose()}
                    >
                      <span className="m-2">CANCEL</span>
                    </AdminButton>
                    <AdminButton
                      width="266px"
                      height="52px"
                      type="submit"
                      background="#7065E4"
                      border-radius="5px"
                      color="white"
                    >
                      UPDATE
                    </AdminButton>
                  </div>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </div>
      </Modal>
      <ChangeSaved show={onSuccessShow} title={onSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </>
  );
};

export default UpdateProductOfferModal;
